import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/api";
import { ArrowLeft } from "@phosphor-icons/react";

export default function SpeakerDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/speakers/${id}`).then((r) => setData(r.data)); }, [id]);
  if (!data) return <div className="py-10 text-center text-[#7A828C]">Loading…</div>;
  const sp = data.speaker;

  return (
    <div data-testid="speaker-detail-page" className="space-y-6">
      <Link to="/speakers" className="inline-flex items-center gap-1 text-sm text-[#5a5a5a] hover:text-[#000000]">
        <ArrowLeft size={16} /> Speakers
      </Link>
      <div className="flex flex-col sm:flex-row gap-4 items-start">
        <div className="w-28 h-28 rounded-sm bg-[#E5E9F0] overflow-hidden flex-shrink-0">
          {sp.photo_url ? <img src={sp.photo_url} alt={sp.name} className="w-full h-full object-cover" /> : null}
        </div>
        <div>
          <h1 className="font-display text-2xl sm:text-3xl leading-tight">{sp.name}</h1>
          <div className="text-sm text-[#5a5a5a] mt-1">{sp.affiliation}</div>
          {sp.bio && <p className="text-[#5a5a5a] mt-3 leading-relaxed">{sp.bio}</p>}
        </div>
      </div>
      <div>
        <h2 className="font-mono-time text-xs uppercase tracking-widest text-[#7A828C] mb-3">Sessions</h2>
        <div className="space-y-2">
          {data.sessions.map((s) => (
            <Link key={s.id} to={`/program/${s.id}`} data-testid={`speaker-session-${s.id}`}
              className="block p-3 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm hover:border-[#000000] transition-colors">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-mono-time text-xs text-[#000000]">{s.start_time}</span>
                <span className="font-mono-time text-[10px] uppercase text-[#7A828C]">{s.date} · {s.stage_label || s.stage}</span>
              </div>
              <div className="font-medium">{s.title}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
